// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles */
.modern-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--gray-200);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-sm) var(--space-lg);
}

/* Logo Styles */
.header-logo .logo-link {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  text-decoration: none;
  color: inherit;
}

.header-logo-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Navigation Styles */
.header-nav {
  display: flex;
  align-items: center;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: var(--space-lg);
  margin: 0;
  padding: 0;
}

.nav-menu li a {
  text-decoration: none;
  color: var(--gray-600);
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  position: relative;
  padding: var(--space-xs) 0;
}

.nav-menu li a:hover {
  color: var(--accent-blue);
}

.nav-menu li a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  transition: width 0.3s ease;
}

.nav-menu li a:hover::after {
  width: 100%;
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  cursor: pointer;
  gap: 4px;
  padding: var(--space-xs);
  background: transparent;
  border: none;
}

.mobile-menu-toggle span {
  width: 24px;
  height: 2px;
  background: var(--gray-600);
  transition: all 0.3s ease;
  border-radius: 2px;
}

.mobile-menu-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-toggle.active span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}

/* Mobile Navigation */
.mobile-nav {
  display: none;
  background: var(--white);
  border-top: 1px solid var(--gray-200);
  padding: var(--space-lg);
}

.mobile-nav.active {
  display: block;
}

.mobile-nav-menu {
  list-style: none;
  padding: 0;
}

.mobile-nav-menu li {
  margin: var(--space-sm) 0;
}

.mobile-nav-menu li a {
  text-decoration: none;
  color: var(--gray-600);
  font-weight: 500;
  font-size: 1.1rem;
  display: block;
  padding: var(--space-sm) 0;
  border-bottom: 1px solid var(--gray-200);
}

.mobile-cta {
  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);
  color: var(--white) !important;
  text-align: center;
  border-radius: var(--radius-lg);
  margin-top: var(--space-lg);
  border: none !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .header-container {
    padding: var(--space-sm);
  }
  
  .header-nav {
    display: none;
  }
  
  .header-cta {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .logo-text {
    font-size: 1.25rem;
  }
  
  .header-logo-img {
    width: 40px;
    height: 40px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,4EAA4E;EAC5E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4EAA4E;EAC5E,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;EACR,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,wBAAwB;EACxB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,4EAA4E;EAC5E,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Header Styles */\n.modern-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid var(--gray-200);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  transition: all 0.3s ease;\n}\n\n.header-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-sm) var(--space-lg);\n}\n\n/* Logo Styles */\n.header-logo .logo-link {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  text-decoration: none;\n  color: inherit;\n}\n\n.header-logo-img {\n  width: 48px;\n  height: 48px;\n  object-fit: contain;\n}\n\n.logo-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Navigation Styles */\n.header-nav {\n  display: flex;\n  align-items: center;\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  gap: var(--space-lg);\n  margin: 0;\n  padding: 0;\n}\n\n.nav-menu li a {\n  text-decoration: none;\n  color: var(--gray-600);\n  font-weight: 500;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: var(--space-xs) 0;\n}\n\n.nav-menu li a:hover {\n  color: var(--accent-blue);\n}\n\n.nav-menu li a::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  transition: width 0.3s ease;\n}\n\n.nav-menu li a:hover::after {\n  width: 100%;\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  gap: 4px;\n  padding: var(--space-xs);\n  background: transparent;\n  border: none;\n}\n\n.mobile-menu-toggle span {\n  width: 24px;\n  height: 2px;\n  background: var(--gray-600);\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n.mobile-menu-toggle.active span:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.mobile-menu-toggle.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.mobile-menu-toggle.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(7px, -6px);\n}\n\n/* Mobile Navigation */\n.mobile-nav {\n  display: none;\n  background: var(--white);\n  border-top: 1px solid var(--gray-200);\n  padding: var(--space-lg);\n}\n\n.mobile-nav.active {\n  display: block;\n}\n\n.mobile-nav-menu {\n  list-style: none;\n  padding: 0;\n}\n\n.mobile-nav-menu li {\n  margin: var(--space-sm) 0;\n}\n\n.mobile-nav-menu li a {\n  text-decoration: none;\n  color: var(--gray-600);\n  font-weight: 500;\n  font-size: 1.1rem;\n  display: block;\n  padding: var(--space-sm) 0;\n  border-bottom: 1px solid var(--gray-200);\n}\n\n.mobile-cta {\n  background: linear-gradient(135deg, var(--accent-blue) 0%, var(--teal) 100%);\n  color: var(--white) !important;\n  text-align: center;\n  border-radius: var(--radius-lg);\n  margin-top: var(--space-lg);\n  border: none !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .header-container {\n    padding: var(--space-sm);\n  }\n  \n  .header-nav {\n    display: none;\n  }\n  \n  .header-cta {\n    display: none;\n  }\n  \n  .mobile-menu-toggle {\n    display: flex;\n  }\n  \n  .logo-text {\n    font-size: 1.25rem;\n  }\n  \n  .header-logo-img {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
